import React from 'react';

export const inject = (
	str?: string,
	obj?: {
		[key: string]: string | JSX.Element;
	},
): (string | JSX.Element)[] => {
	if (str && obj) {
		return str.split(/\${(.*?)}/g).map((g, i) => {
			const value = obj[g] || g;
			// If it's a JSX element, clone it with a key
			if (React.isValidElement(value)) {
				return React.cloneElement(value, { key: i });
			}
			// For string values no key is required
			return value;
		});
	}
	return [];
};
